/* eslint-disable import/prefer-default-export */
import { FormDataType } from '@types';

import { PaymentCollectionType } from '../../constants';

export const hasFrequencyChanged = (
  current: FormDataType,
  initial: FormDataType
): boolean =>
  current.paymentCollectionType !== initial.paymentCollectionType ||
  current.intervalFrequency !== initial.intervalFrequency ||
  (current.paymentCollectionType !== PaymentCollectionType.ONCE &&
    current.activationDate !== initial.activationDate) ||
  current.isCustomTerm !== initial.isCustomTerm;
